let insightRouteName = ''

export function setInsightRouteName(name: string): void {
  insightRouteName = name
}

export function insightDeepLink(
  insightId: number,
): { name: string; query: { insight_id: number } } | null {
  if (!insightRouteName) return null
  return { name: insightRouteName, query: { insight_id: insightId } }
}
